import React from 'react';
import { TabsTimelineSub } from 'components';
import { tabs } from './tabs';
import { useSelector } from 'react-redux';

const BasicInfo = () => {
  const currentSubTab = useSelector(state => state.forms.carrier.currentSubTab) || 0;

  return (
    <TabsTimelineSub
      tabs={tabs()}
      currentSubTab={currentSubTab} 
      customClass={'custom-tabs-timeline-sub'}
    />
  );
};

export default BasicInfo;